module.exports = __webpack_public_path__ + "static/img/DrPuneetVerma.af0a268.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/DrPuneetVerma.png
// module id = 8UmM
// module chunks = 1